export const withoutAuthRoute = [
    "login",
    "register",
    "forget-password",
    "reset-password"
  ];